import {httpUrl} from './httpUrl'

let baseUrl2 = `${httpUrl.host}/gy-interaction`
let baseUrl3 = `${httpUrl.host}/gy-apartment`
// let baseUrl2 = `${httpUrl.host}`
// let baseUrl = '/api/sc-enterprise'

let api = {
  // 概览
  getRepairOverview: `${baseUrl2}/repairOverview/getRepairOverview`,

  getRepairConsumptionRecordStatictics: `${baseUrl2}/repairOverview/getRepairConsumptionRecordStatictics`,

  getRepairRecordStatictics: `${baseUrl2}/repairOverview/getRepairRecordStatictics`,

  // 报修类别分页
  getRepairCategoryPage: `${baseUrl2}/repairCategory/getPage`,

  // 报修类别列表
  getRepairCategoryList: `${baseUrl2}/repairCategory/getList`,

  // 添加报修类别
  addRepairCategory: `${baseUrl2}/repairCategory/add`,

  // 删除报修类别
  deleteRepairCategoryByCodes: `${baseUrl2}/repairCategory/deleteByCodes`,

  // 修改报修类别
  updateRepairCategory: `${baseUrl2}/repairCategory/update`,

  // 导出报修记录
  exportRepairCategory: `${baseUrl2}/repairRecord/export`,

  // 报修记录分页
  getRepairRecordPage: `${baseUrl2}/repairRecord/getPage`,

  // 报修记录详情
  getRepairRecordByCode: `${baseUrl2}/repairRecord/getByCode`,

  // 报修缴费记录
  getRepairPayRecordPage: `${baseUrl2}/repairConsumptionRecord/getPage`,

  // 导出缴费记录
  exportRepairPayRecord: `${baseUrl2}/repairConsumptionRecord/export`,

  // 维修工分页
  getRepairManPage: `${baseUrl2}/repairMan/getPage`,

  // 添加维修工
  addRepairMan: `${baseUrl2}/repairMan/add`,

  // 修改维修工
  updateRepairMan: `${baseUrl2}/repairMan/update`,

  // 删除维修工
  deleteRepairManByCodes: `${baseUrl2}/repairMan/deleteByCodes`,

  // 人员列表
  getResponsiblePersonList: `${baseUrl3}/person/getResponsiblePersonList`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/RepairManagement.js